namespace SPA
{
	export namespace gui
	{

		export class Listing<T>
			extends ui.base.HTMLPresentation<HTMLDivElement>
		{
			private m_FilterRow: JQuery<HTMLElement>;
			private m_ContentRow: JQuery<HTMLElement>;
			private	m_Table: ui.table.Table<T>;
			private m_Pagination: ui.paging.Pagination;
			private m_ContentFilter?: ui.Form.Form;
			private	m_Data: T[];
			private	m_PerSite: number;
			private m_ShowPagination: boolean;
			private	m_Page: number;
			private	m_Load: ( list: Listing<T>, count: number, page: number ) => void;

			public constructor( tablemodel: ui.table.DataModel<T>, maxPerSite: number, loadingFunc: ( list: Listing<T>, count: number, page: number ) => void )
			{
				super( 'div' );

				this.m_FilterRow			= ui.$$.div();
				this.m_ContentRow			= ui.$$.div();
				this.m_Table					= new ui.table.Table();
				this.m_Pagination			= new ui.paging.Pagination( { center: true, jumper: true, sync: 1 } );
				this.m_Data						= [];
				this.m_PerSite				= clamp( maxPerSite, 5, 50 );
				this.m_Page						= 0;
				this.m_Load						= loadingFunc;
				this.m_ShowPagination	= true;

				this.Initialize(
					{
						classes: [ 'container-fluid' ]
					}
				);

				this.m_Table.DataModel( tablemodel );

				this.m_FilterRow.addClass( 'row' ).appendTo( this.m_Root );
				this.m_ContentRow.addClass( 'row' ).appendTo( this.m_Root );

				this.m_Load( this, this.m_PerSite, 0 );
			}

			public showPagination( show: boolean ): void
			{
				this.m_ShowPagination	= show;
			}

			public Data(): T[];
			public Data( data: T[] ): void;

			public Data( data?: T[] ): T[]|void
			{
				if ( data )
				{
					this.m_Data = data;

					const model = this.m_Table.DataModel();
					if ( model )
					{
						const reader = model.ModelReader();

						if ( reader )
						{
							reader.Data( this.m_Data );
						}
					}

					return;
				}

				return this.m_Data;
			}

			public Content(): ui.table.Table<T>
			{
				return this.m_Table;
			}

			public Filter(): ui.Form.Form|undefined;
			public Filter( filter: ui.Form.Form ): void;
			public Filter( filter?: ui.Form.Form ): ui.Form.Form|undefined|void
			{
				if ( filter )
				{
					this.m_ContentFilter = filter;

					return;
				}

				return this.m_ContentFilter;
			}

			public Pagination(): ui.paging.Pagination
			{
				return this.m_Pagination;
			}

			public SetPage( page: number, number: number ): void
			{
				this.m_Page = page;
				let page_		= 0;

				this.m_Pagination.Clear();

				/* Auskommentierten Code wieder einfügen, falls die Seitenzahl Berechnungen fehlerhaft sind */
				while ( number /*/ this.m_PerSite*/ > 0 /*.0*/ && ++page_ )
				{
					this.m_Pagination.AddItem(
						page_.toString(),
						(( p_Page ) => (): void => { this.m_Load( this, this.m_PerSite, p_Page ); } )( page_ - 1 )
					);

					number -= this.m_PerSite;
				}

				if ( this.m_ShowPagination )
				{
					this.m_Pagination.SetActive( page );
					this.m_Pagination.rebuild();
				}
			}

			public reload( root: JQuery<HTMLElement>|ui.base.BaseHTMLElement ): void
			{
				this.m_Load( this, this.m_PerSite, this.m_Page );

				this.rebuild( root );
			}

			public rebuild( root: JQuery<HTMLElement>|ui.base.BaseHTMLElement ): Listing<T>
			{
				this.appendTo( root );

				// baue filter options
				this.m_FilterRow.empty();

				this.m_ContentRow.empty();
				// if ( this.m_ShowPagination ) { this.m_ContentRow.append( this.m_Pagination.Root( 0 ) ); }
				this.m_Table.appendTo( this.m_ContentRow );
				if ( this.m_ShowPagination ) {this.m_ContentRow.append( this.m_Pagination.Root( 1 ) ); }

				if ( this.m_ShowPagination ) { this.m_Pagination.rebuild(); }

				return this;
			}

		}

	}
}
